import { Dispatch, FC, useState, useEffect, Fragment } from "react";
import {
  Box,
  ButtonProps,
  FormControl,
  CardContent,
  Container,
  CssBaseline,
  Card,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  styled,
  Backdrop,
  CircularProgress,
  AppBar,
  Paper,
  Grid,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDispatch } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";
import UserInformation from "../../types/UserInformation";
import { profilToAccessToAllFonctionnality } from "../../constants/Constants";
import { loggingUser, loggoutUser } from "../../redux/actions/logginUser";
import AccountForm from "./AccountForm";
import { DataRef } from "../../types/DataRef";
import PasswordForm from "./PasswordForm";
interface LoginProps {
  setIsLogged: Dispatch<React.SetStateAction<boolean>>;
}

const SetTokens: FC<LoginProps> = ({ setIsLogged }) => {
  const [logger, setLogger] = useState<UserInformation>();
  const [hideEditPassword, setHideEditPassword] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cookies = new Cookies();
  const baseUrlApi = process.env.REACT_APP_BASE_API_URL as string;

  const params = useParams();
  const token = params.token;
  const http = axios.create({
    withCredentials: true,
    baseURL: baseUrlApi,
  });

  useEffect(() => {
    if (token?.includes("|")) {
      cookies.set("jwt", token, { path: "/" });
      setIsLogged(true);
      http
        .get("user/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          const {
            id,
            name,
            prenom,
            email,
            Departement,
            pays,
            profils,
            features,
          } = res.data as UserInformation;

          const user: UserInformation = {
            id,
            name,
            prenom,
            email,
            Departement,
            pays,
            token,
            profils,
            features,
            updated_password: false,
            password_expired: false
          };

          setLogger(user);

          // Profil de l'utilisateur, envoye au back via le header X-Profil-Id
          if (profils?.id) {
            cookies.set("profil_id", profils.id, { path: "/" });
          }

          dispatch(loggingUser(user));

          http
            .get(`user/restoremdpbytokenhead/${token}`)
            .then((res) => {
              // navigate('/account');
              if (res.data === 0) {
                // Token Expirer Apres Une Heure
                dispatch(loggoutUser());
                cookies.remove("jwt", { path: "/" });
                navigate("/sign-in");
              } else {
                // Token Non Expirer
                setHideEditPassword(false);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          dispatch(loggoutUser());
          cookies.remove("jwt", { path: "/" });
          navigate("/sign-in");
        });
    }
  }, []);

  return (
    <div>
      {hideEditPassword ? (
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={token?.includes("|") === true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          marginTop={20}
        >
          <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
            <Paper
              variant="outlined"
              sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
            >
              <Typography component="h1" variant="h4" align="center">
                Mon compte
              </Typography>
              <Fragment>
                <PasswordForm user={logger as UserInformation} />
              </Fragment>
            </Paper>
          </Container>
        </Grid>
      )}
    </div>
  );
};

export default SetTokens;
